import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../images/Sukritu.jpeg";
import img2 from "../images/Divya.jpeg";
import img3 from "../images/Vishal.jpeg";

const testimonials = [
  {
    image: img1,
    para: "Precision, Consistency, and Results, As a Project Manager, I am used to managing timelines for others, but I struggled to navigate my own personal growth. Anchor Point has been a pivotal turning point for me. The coaching provided the clarity I needed to effectively set and prioritize my goals. What truly stands out is their consistency; the regular follow-ups kept me accountable and ensured that I didn't just dream, but actually executed. Every session had a lasting impact, and I highly recommend their services to anyone looking to find their 'anchor' in life.",
    name: "Sukriti,",
    location: "Project Manager, Ghaziabad, India",
  },
  {
    image: img2,
    para: "Finding Direction and Professional Clarity Coming from an HR background, I understand the value of development, but I needed a personal breakthrough to navigate my own path. Anchor Point helped me peel back the layers and truly define my goals with precision. Before starting, I felt like I was drifting; now, I have a clear sense of direction and the tools to navigate challenges more effectively. It is an investment in yourself that truly pays off.",
    name: "Divya Yadav,",
    location: "HR Professional, India",
  },
  {
    image: img3,
    para: "Building a Deeper Connection with Myself In the fast-paced IT industry, it’s easy to get lost in deadlines and external demands. Anchor Point helped me pause and truly understand myself on a level I hadn't explored before. The sessions provided a unique space to move beyond the daily grind and create a genuine connection with myself. This newfound self-awareness has made me more grounded and effective in both my life and my career.",
    name: "Vishal,",
    location: "IT Professional, India",
  },
];

const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    pauseOnHover: true,
    className: "testimonial-slider",
  };

  return (
    <section className="testimonial-section animate">
      <div className="container">
        <h2 className="text-center mb-5">What Our Clients Say</h2>
        <div className="testimonial-slider-container">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-slide">
                <div className="testimonial-card">
                  <div className="testimonial-img-container">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="testimonial-img"
                    />
                  </div>
                  <div>
                    {" "}
                    <p className="testimonial-para">"{testimonial.para}"</p>
                    <h5 className="testimonial-name">{testimonial.name}</h5>
                    <span className="testimonial-location">
                      {testimonial.location}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
